module.exports = __webpack_public_path__ + "img/star.105cc6e1.svg";